<template>
  <router-view></router-view>
</template>

<script>
import store from '@/components/store.js'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'app',
  components: {
    store
  },
  beforeCreate () {
    this.$user().isAuthenticated().catch(e => {
      this.$router.push('/login')
    })
  },
  methods: {
    ...mapActions([
      'updateUser'
    ]),
    logout () {
      this.$user().logout().then(() => {
        this.$router.push('/login')
      })
    },
    toggleSidebar () {
      if (this.size === 'large') {
        this.$set(this, 'size', 'small')
        return false
      }
      this.$set(this, 'size', 'large')
    },
    getWidth () {
      console.log(document.body.scrollWidth)
      return document.body.scrollWidth
    },
    checkWidth () {
      if (this.getWidth() > this.hiddenWidth) {
        return false
      }
      this.$set(this, 'size', 'large')
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// App.vue?5db23a7e